// extracted by mini-css-extract-plugin
export default {"voucherDisplay":"VoucherDisplay_voucherDisplay__pRXa1","leftSection":"VoucherDisplay_leftSection__QST9-","rightSection":"VoucherDisplay_rightSection__KC4tK"};